export default "__VITE_PUBLIC_ASSET__d4e05434__"